/*
  ---- custom directive equivalent to v-html ----
  ---- Default allowed tags : B,I,A ----
  ---- Default allowed attribures : href, target ----
  ---- The defaut allowed tags and allowed attributes can be overridden ----
  ---- If the default values has to be overridden pass the value as an object with keys: text, attrs & tags with corresponding values ----
  ---- Param desc: text => string; attrs: array of string; tags: array of string ----
*/

import Vue from 'vue';

export default {
  inserted: function(el, binding, vnode) {
    if (!binding && !binding.value) {
      return;
    }
    new VHtmlHandler(el, vnode, binding).stripTag();
  },

  bind: function(el, binding, vnode) {
    if (!binding && !binding.value) {
      return;
    }
    new VHtmlHandler(el, vnode, binding).stripTag();
  },

  update: function(el, binding, vnode) {
    if ((el.tagName == 'TEXTAREA' || el.contentEditable == "true") || (!binding && !binding.value)) {
      return;
    }
    new VHtmlHandler(el, vnode, binding).stripTag();
  },
}


class VHtmlHandler {
  el;
  vnode;
  value;
  allowedTags;
  allowedAttrs;
  restrictedTags;
  constructor(el, vnode, binding) {
    this.el = el;
    this.vnode = vnode;
    this.value = binding.value.constructor == Object ? binding.value.text || "" : binding.value || "";
    this.allowedTags = binding.value.tags || ['B', 'I', 'A', 'BR'];
    this.allowedAttrs = binding.value.attrs || [{ tagName: 'A', attrs: ['href', 'target'] }];
  }

  toArray(nl) {
    for (var a = [], l = nl.length; l--; a[l] = nl[l]);
    return a;
  }

  stripAttrs(node) {
    node && node.attributes && this.toArray(node.attributes).forEach((attr) => {
      let filteredAttrs = this.allowedAttrs.filter((k) => k.tagName == node.nodeName)[0];
      filteredAttrs = filteredAttrs && filteredAttrs.attrs || [];
      filteredAttrs.indexOf(attr.name) == -1 && node.removeAttribute(attr.name);
    });
    return node;
  }

  unescapeHTML(s) {
    if (typeof(s) !== 'string') {
      s = s + '';
    }
    return s.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
  }

  replaceNodes(pnode) {
    if (pnode.childNodes && pnode.childNodes.length > 0) {
      [...pnode.childNodes].forEach((node) => {
        if (node.nodeType == 1) {
          if (this.allowedTags.indexOf(node.nodeName) != -1) {
            node.parentElement.replaceChild(this.stripAttrs(node), node);
            this.replaceNodes(node);
          } else {
            let text = document.createTextNode("");
            node.parentElement.replaceChild(text, node);
          }
        }
      })
    }
    return pnode;
  }

  parseChildNodes(parentNode, output) {
    [...parentNode.childNodes].forEach((node) => {
      if (node.nodeType == 1) {
        let temp = node.children && node.children.length > 0 && this.replaceNodes(node.cloneNode(true)) || node;
        output += this.allowedTags.indexOf(node.nodeName) != -1 ? this.stripAttrs(temp).outerHTML : "";
      }
      if (node.nodeType == 3) {
        output += node.textContent;
      }
    });
    return output;
  }

  checkForRestricedTags(value) {
    let scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    return scriptRegex.test(value) ? value.replace(scriptRegex, "") : value;
  }

  stripTag() {
    let target = document.createElement("div");
    target.innerHTML = this.unescapeHTML(this.value); //check for &lt; symbols
    let output = "";
    output = this.unescapeHTML(this.parseChildNodes(target, "")); //double check escaped html
    this.el && (this.el.innerHTML = this.checkForRestricedTags(output)); //double check removal of script tags
  }
}


// WEBPACK FOOTER //
// ./src/directives/vhtml.js